export const WEB_PUSH_PUBLIC_KEY =
  process.env.PWA_PUBLIC_KEY ||
  "BFHJ7aj7XaCN8tQFORtPwIq096Wwj-zkvX0pQ2uu1Ec-SAer0orGjxfKKBhBvj4byUU4Lt7Ba0IPKBOoYeH8WJQ";
